<template>
	<div class="pagination" v-bind:class="hideClass">
		<a v-if="page > 1" class="pagination__prev" href="javascript:void(0);" v-on:click="setPage(page - 1)" title="Previous Page">« Previous Page</a>
		<ol>
			<li v-show="page > (show_previous + 1)">
				<a href="javascript:void(0);" v-on:click="setPage(1)">1</a>
			</li>
			<li v-show="page > (show_previous + 2)" class="paging-elips">
				<span>...</span>
			</li>
			<li v-for="n in max_page" v-if="n > page - (show_previous + 1) && n <= page + show_next" v-bind:class="{ pagination__current : n == page}">
				<a href="javascript:void(0);" v-on:click="setPage(n)">{{n}}</a>
			</li>
			<li v-show="max_page > page + show_next" class="paging-elips">
				<span>...</span>
			</li>
			<li v-show="max_page > page + (show_next)">
				<a href="javascript:void(0);" v-on:click="setPage(max_page)">{{max_page}}</a>
			</li>
		</ol>
		<a v-if="page < max_page" class="pagination__next" href="javascript:void(0);" v-on:click="setPage(page + 1)" title="Next Page">Next Page »</a>
	</div>
</template>

<script>
	export default {
		name: 'Paging',
		data: function(){
			return {
				show_previous:1,
				show_next:3,
			};
		},
		computed:{
			page:{
				get: function(){
					return this.$parent.page;
				}
			},
			max_page: function(){
				return this.$parent.max_page;
			},
			hideClass: function(){
				return {
					hidden: this.$parent.max_page < 2
				}
			}
		},
		methods:{
			setPage: function(num){
				this.$parent.page = num;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Paging.vue